import { GridRowHeightEnum } from "../../../@types/enumsGlobal";
import i18n from "../../../i18n";
import ImportedInvoiceItemGridPluginSettings from "./ImportedInvoiceItemGridPluginSettings";

const GlobalImportInvoicesGridPluginSettings: IPluginSettings = {
    name: "Общий импорт накладных",
    mnemocode: "global_import_invoices_plugin",
    permission: "GlobalImportInvoices",
    rowHeight: GridRowHeightEnum.normal,
    columns: [
        {
            order: -1,
            propertyName: "importStatus",
            propertyType: "string",
            displayName: "",
            visibility: true,
            width: 50,
            sorting: false
        },
        {
            order: 0,
            propertyName: "fileName",
            propertyType: "string",
            displayName: "Имя файла",
            visibility: true,
            width: 250
        },
        {
            order: 1,
            propertyName: "statusDisplay",
            propertyType: "string",
            displayName: "Статус",
            visibility: true,
            width: 120
        },
        {
            order: 2,
            propertyName: "matchingStatus",
            propertyType: "string",
            displayName: i18n.t("documents.globalImportInvoices.matchingStatus.header"),
            visibility: true,
            width: 150,
            sorting: false
        },
        {
            order: 3,
            propertyName: "supplierDocNum",
            propertyType: "string",
            displayName: "Номер накладной",
            visibility: true,
            width: 150
        },
        {
            order: 4,
            propertyName: "supplierDocDate",
            propertyType: "date",
            displayName: "Дата накладной",
            visibility: true,
            width: 150
        },
        {
            order: 5,
            propertyName: "supplierName",
            propertyType: "string",
            displayName: "Поставщик",
            visibility: true,
            width: 200
        },
        {
            order: 6,
            propertyName: "contractorName",
            propertyType: "string",
            displayName: "Грузополучатель",
            visibility: true,
            width: 200
        },
        {
            order: 7,
            propertyName: "storeName",
            propertyType: "string",
            displayName: "Склад",
            visibility: false,
            width: 200,
            sorting: false
        },
        {
            order: 8,
            propertyName: "idContractorGlobal",
            propertyType: "string",
            displayName: "IdContractorGlobal",
            visibility: false,
            width: 150
        },
        {
            order: 9,
            propertyName: "idSupplierGlobal",
            propertyType: "string",
            displayName: "IdSupplierGlobal",
            visibility: false,
            width: 150
        },
        {
            order: 10,
            propertyName: "idStoreGlobal",
            propertyType: "string",
            displayName: "IdStoreGlobal",
            visibility: false,
            width: 150
        },
        {
            order: 11,
            propertyName: "idImportedInvoiceGlobal",
            propertyType: "string",
            displayName: "IdImportedInvoiceGlobal",
            visibility: false,
            width: 150
        },
        {
            order: 12,
            propertyName: "idInvoiceGlobal",
            propertyType: "string",
            displayName: "IdInvoiceGlobal",
            visibility: false,
            width: 150
        },
        {
            order: 13,
            propertyName: "connectionString",
            propertyType: "string",
            displayName: "ConnectionString",
            visibility: false,
            width: 150
        },
        {
            order: 14,
            propertyName: "status",
            propertyType: "string",
            displayName: "Статус (служебный)",
            visibility: false,
            width: 120,
            translation: "statusDisplay"
        },
        {
            order: 15,
            propertyName: "statusOriginal",
            propertyType: "string",
            displayName: "Статус оригинал",
            visibility: false,
            width: 120
        }
    ],
    detailsPlugins: [ImportedInvoiceItemGridPluginSettings]
};

export default GlobalImportInvoicesGridPluginSettings;
